/**
 * @generated SignedSource<<0a3c91ed79c0b02bb0407c60b6ee9489>>
 * @relayHash c55e645a74170fdd11476ed02122d5a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21039befd11257c3478ba08dae0d42694cdb2a2c8599a5dc12d807a6a3610bc7

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type updateHideDoneStateMutation$variables = {
  cloudId: string;
  isHideDoneEnabled: boolean;
};
export type updateHideDoneStateMutation$data = {
  readonly jira: {
    readonly userPreferences: {
      readonly setIsIssueViewHideDoneChildIssuesFilterEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateHideDoneStateMutation$rawResponse = {
  readonly jira: {
    readonly userPreferences: {
      readonly setIsIssueViewHideDoneChildIssuesFilterEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateHideDoneStateMutation = {
  rawResponse: updateHideDoneStateMutation$rawResponse;
  response: updateHideDoneStateMutation$data;
  variables: updateHideDoneStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isHideDoneEnabled"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserPreferencesMutation",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isHideDoneEnabled",
                "variableName": "isHideDoneEnabled"
              }
            ],
            "kind": "ScalarField",
            "name": "setIsIssueViewHideDoneChildIssuesFilterEnabled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "updateHideDoneStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateHideDoneStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "21039befd11257c3478ba08dae0d42694cdb2a2c8599a5dc12d807a6a3610bc7",
    "metadata": {},
    "name": "updateHideDoneStateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6babc4ed1c077329c89c7abdb79da681";

export default node;
